<template>
  <div class="p-profile">
    <!--TODO: Add el-scrollbar-->
    <div class="p-profile__card">
      <company-card />
    </div>
    <div class="p-profile__card">
      <contact-list-card />
    </div>
    <div
      v-if="showDeleteAccountCard"
      class="p-profile__card"
    >
      <delete-account-card />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompanyCard from '@/app/components/profile/CompanyCard';
import ContactListCard from '@/app/components/profile/ContactListCard';
import DeleteAccountCard from '@/app/components/delete-account/DeleteAccountCard.vue';
import { CustomerType } from '@/app/services/DeleteAccountService';

export default {
  name: 'Profile',
  components: {
    CompanyCard,
    ContactListCard,
    DeleteAccountCard
  },
  computed: {
    ...mapGetters('app', [
      'customerType'
    ]),
    showDeleteAccountCard() {
      return this.customerType === CustomerType.acronis_backup;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-profile {
  height: 100%;
  padding: 24px;
  overflow: auto;

  &__card {
    max-width: 832px;
    margin: 0 auto 24px auto;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
